export enum ElementType {
    // eslint-disable-next-line id-denylist
    String = 'S',
    // eslint-disable-next-line id-denylist
    Number = 'N',
    Date = 'D',
    Unknown = '',
}

export enum ApplicationIdentifier {
    ProductIdentifier = '240',
    SerialNumber = '21',
    LotNumber = '10',
    Default = '',
}
